var DimensionsHelper = /** @class */ (function () {
    function DimensionsHelper() {
        this.styles = {};
        this.container = {};
        this.domId = '';
        this._cache = {};
    }
    DimensionsHelper.prototype.getOrPutInCache = function (field, createValue) {
        if (this._cache[field])
            return this._cache[field];
        this._cache[field] = createValue();
        return this._cache[field];
    };
    DimensionsHelper.prototype.dumpCache = function () {
        this._cache = {};
    };
    DimensionsHelper.prototype.updateParams = function (_a) {
        var styles = _a.styles, container = _a.container, domId = _a.domId;
        this.dumpCache();
        this.domId = domId || this.domId;
        this.styles = styles || this.styles;
        this.container = container || this.container;
    };
    DimensionsHelper.prototype.getGalleryDimensions = function () {
        var _this = this;
        return this.getOrPutInCache('galleryDimensions', function () {
            var res = {
                galleryWidth: Math.ceil(_this.getGalleryWidth()),
                galleryHeight: Math.ceil(_this.getGalleryHeight()),
                scrollBase: _this.container.scrollBase
                    ? Math.ceil(_this.container.scrollBase)
                    : 0,
                height: Math.ceil(_this.container.height),
                width: Math.ceil(_this.container.width),
            };
            if (_this.container.externalScrollBase) {
                //if was provided from the wrapper
                res.scrollBase += _this.container.externalScrollBase;
            }
            if (_this.styles.hasThumbnails) {
                var fixedThumbnailSize = _this.styles.thumbnailSize +
                    _this.styles.galleryMargin +
                    3 * _this.styles.thumbnailSpacings;
                switch (_this.styles.galleryThumbnailsAlignment) {
                    case 'top':
                    case 'bottom':
                        res.galleryHeight -= fixedThumbnailSize;
                        break;
                    case 'left':
                    case 'right':
                        res.galleryWidth -= fixedThumbnailSize;
                        break;
                    default:
                        break;
                }
            }
            else if (_this.styles.isSlideshow) {
                res.galleryHeight -= _this.styles.slideshowInfoSize;
            }
            return res;
        });
    };
    DimensionsHelper.prototype.getGalleryWidth = function () {
        var _this = this;
        return this.getOrPutInCache('galleryWidth', function () {
            var width = Math.floor(_this.container.width) + _this.getDimensionFix() * 2; //add margins to width and then remove them in css negative margins
            if (_this.styles.arrowsPosition && _this.styles.oneRow) {
                width -=
                    2 * (_this.styles.arrowsSize + 40 + _this.styles.imageMargin / 2);
            }
            return width;
        });
    };
    DimensionsHelper.prototype.getGalleryHeight = function () {
        var _this = this;
        return this.getOrPutInCache('galleryHeight', function () {
            //const offsetTop = this.styles.oneRow ? this.container.offsetTop : 0;
            var dimensionFix = function () {
                return _this.styles.oneRow ? _this.getDimensionFix() : 0;
            };
            var res = Math.floor((_this.container.height > 0 ? _this.container.height : 0) + dimensionFix());
            return res;
        });
    };
    DimensionsHelper.prototype.getDimensionFix = function () {
        var _this = this;
        return this.getOrPutInCache('dimensionFix', function () {
            return (Number(_this.styles.imageMargin / 2) - Number(_this.styles.galleryMargin));
        });
    };
    DimensionsHelper.prototype.getGalleryRatio = function () {
        var _this = this;
        return this.getOrPutInCache('galleryRatio', function () {
            var res = _this.getGalleryDimensions();
            return res.galleryWidth / res.galleryHeight;
        });
    };
    return DimensionsHelper;
}());
export default new DimensionsHelper();
//# sourceMappingURL=dimensionsHelper.js.map